import ClinicalNotesScreen from "../../components/ipd/clinicalNotes/ClinicalNotesScreen";

function NursingNotes() {
  return (
    <ClinicalNotesScreen
      screenTitle="Nursing Notes"
      notesLabel="Nursing Notes"
      staffLabel="Nurse Name"
      isNursingNotes={true}
      useLiveApi
    />
  );
}

export default NursingNotes;
